import styled from 'styled-components'

const BoldText = styled.div`
  font-weight: 600;
`

export default BoldText
